/**
 *  Set Home URL based on User Roles
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getHomeRoute = (rolename: string) => {
  // TODO: Set Home URL based on User Roles
  return '/app/restaurant'
}

export default getHomeRoute
